import { Component, ViewChild } from '@angular/core';
import { IRegistrationModel } from '../../../models/dynamic-form-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CommonConstant } from '../../../enums/common-constant';
import { Router } from '@angular/router';
import { CommonMessage } from '../../../enums/message';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrl: './home-content.component.scss'
})
export class HomeContentComponent {

    public defaultSortCol = { name: 'createdAt', direction: 'desc' };
    public defaultPage = { size: 10, page: 0 };  
    registrations = new MatTableDataSource<IRegistrationModel>();
    @ViewChild('registrationsPaginator') registrationsPaginator !:MatPaginator;
    @ViewChild('registrationsMatSort') registrationsMatSort: MatSort;


    displayedColumns: string[] = ['formName', 'formDescription', 'startDate', 'endDate', 'id'];
    isLoading = false;
    totalRows = 0;
    pageSize = this.defaultPage.size;
    currentPage = 0;
    pageSizeOptions: number[] = [5, 10, 20, 100];
  
    constructor( private router: Router ) {
    }
  
    ngOnInit(): void {
      this.myRegistrations(this.defaultSortCol.name,this.defaultSortCol.direction, this.defaultPage.page, this.defaultPage.size);
    }
    ngAfterViewInit() {
      this.registrations.sort = this.registrationsMatSort;
      this.registrations.paginator = this.registrationsPaginator;
      this.registrationsPaginator._intl.itemsPerPageLabel = CommonConstant.ITEMS_PER_PAGE;
      this.registrationsPaginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return `${startIndex + 1} của ${endIndex} / ${length}`;
      }
    }
   
    myRegistrations(sortBy: string, sortDirection: string, page: number, size: number):void {
      this.isLoading = true;
      // this.dynamicFormResponService.myRegistrations(page, size, sortBy,sortDirection).subscribe({
      //   next: (data: any) => {
      //     this.registrations.data = data.rows;
      //     this.registrations.sort = this.registrationsMatSort;
  
      //     setTimeout(() => {
      //       this.registrationsPaginator.pageIndex = this.currentPage;
      //       this.registrationsPaginator.length = data.totalElements;
      //     });
      //     this.isLoading = false;
      //   },
      //   error: (error) => {
      //     console.log(CommonMessage.TITLE_ERROR, error)
      //     this.isLoading = false;
      //   } 
      // });   
      this.registrations.sort = this.registrationsMatSort;
      this.isLoading = false;
     
    }
    public handlePageEvent(event: PageEvent) {
      this.pageSize = event.pageSize;
      this.currentPage = event.pageIndex;   
      this.myRegistrations(this.defaultSortCol.name,this.defaultSortCol.direction,  event.pageIndex, event.pageSize);
    
    }

    public myRegistrationDetail(formId: number) {
      this.router.navigate(['/my-registration'], {
        queryParams: {
          formId: formId
        }
      });
     
    }
    public handleSortChange(sortState: Sort) {
       this.myRegistrations(sortState.active,sortState.direction, this.registrationsPaginator.pageIndex, this.registrationsPaginator.pageSize);
    }

}
